import { createContext } from '../utils';
var ModalContext = createContext(null);
export default ModalContext;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rsuite/es/Modal/ModalContext.js
// module id = 566
// module chunks = 35